var storefrontApp = angular.module("storefrontApp");

//#region URL Service
storefrontApp.service("urlService", [
    "$location",
    "catalogService",
    "configs",
    "$http",
    function ($location, catalogService, configs, $http) {
        return {
            getBrandUrl: function (item) {
                if (item) {
                    if (catalogService.isSubscription(item.productDefinition)) {
                        return "/account#/#customersubscription";
                    }
                    if (catalogService.isDigitalProduct(item.productType)) {
                        if (
                            item.catalogId &&
                            item.catalogId.toLowerCase() == "annthegranpl"
                        )
                            item.catalogId = "ann the gran";

                        if (
                            catalogService.isCustomDigitizing(
                                item.productDefinition
                            )
                        )
                            return "/customdigitizing";
                        else if (
                            catalogService.isInstantLettering(
                                item.productDefinition
                            )
                        )
                            return "/";
                        else if (
                            item.catalogId &&
                            item.catalogId.toLowerCase() == "atg freedesigns"
                        )
                            return "/freeembroiderydesigns";
                        else
                            return (
                                "/all/brands/" +
                                item.catalogId
                                    .replace(/ /g, "-")
                                    .toLowerCase() +
                                "/all"
                            );
                    } else if (
                        catalogService.isClubMembership(item.productType)
                    )
                        return "/annsclub";

                    if (
                        item.productDefinition &&
                        item.productDefinition.toLowerCase() ==
                            "instantlettering"
                    )
                        return null;
                } else return null;
            },
            getImageUrl: function (item) {
                if (angular.isDefined(item)) {
                    var imgUrl = "";
                    if (window.__env && window.__env.elasticBaseUrl) {
                        configs = window.__env;
                    }

                    //#region  Definition Name
                    var definitionName = "";
                    if (angular.isDefined(item.definitionName)) {
                        definitionName = item.definitionName
                            .replace(/ /g, "-")
                            .toLowerCase();
                    } else if (angular.isDefined(item.productDefinition)) {
                        definitionName = item.productDefinition
                            .replace(/ /g, "-")
                            .toLowerCase();
                    }
                    if (definitionName.toLowerCase() == "svg") {
                        definitionName = "printart";
                    }
                    if (
                        definitionName.toLowerCase().indexOf("pdf-patterns") >
                            -1 ||
                        definitionName.toLowerCase() == "hand-embroidery"
                    ) {
                        definitionName = "projectpack";
                    }
                    //#endregion

                    //#region Subscription
                    if (
                        definitionName.toLowerCase() ==
                        catalogService.productDefinition.subscription.toLowerCase()
                    ) {
                        return (
                            "/embroiderydesigns/images/subscriptions/" +
                            (item.size || "medium") +
                            "/subscription.jpg"
                        );
                    }
                    //#endregion

                    // #region Lookbook
                    if (definitionName.toLowerCase() == "lookbook") {
                        var lookbookBaseUrl = window.__env.lookbookImgBaseUrl;
                        var isCover = angular.isUndefined(item.pageNumber);
                        if (isCover) {
                            lookbookBaseUrl += "supersize/cover/";
                        } else {
                            lookbookBaseUrl += "thumbnail/";
                        }
                        return (
                            lookbookBaseUrl +
                            item.lookbookId +
                            (isCover ? "" : "-" + item.pageNumber) +
                            ".jpg"
                        ).toLowerCase();
                    }
                    //#endregion

                    //#region Project Tutorials
                    if (
                        item.definitionName &&
                        item.definitionName.toLowerCase() == "project_tutorial"
                    ) {
                        if (item.imgName.indexOf("_t") < 0) {
                            return (
                                window.__env.projectTutorialsBaseUrl +
                                item.imgName
                            ).toLowerCase();
                        } else {
                            return (
                                window.__env.projectTutorialsBaseUrl +
                                item.imgName.substring(
                                    0,
                                    item.imgName.lastIndexOf("_t")
                                ) +
                                item.imgName.substring(
                                    item.imgName.lastIndexOf("_t") + 2
                                )
                            ).toLowerCase();
                        }
                    }
                    //#endregion

                    //#region Gift Certificate
                    if (
                        definitionName.toLowerCase() == "giftcertificate" &&
                        item.giftCardItems &&
                        item.giftCardItems.length > 0
                    ) {
                        imgUrl = "/embroiderydesigns/images/giftcards/medium/";
                        return imgUrl.toLowerCase();
                    }
                    //#endregion

                    // #region Custom Digitizing
                    if (
                        definitionName.toLowerCase() == "customdigitizing" &&
                        item.customDigitizingItems &&
                        item.customDigitizingItems.length > 0
                    ) {
                        imgUrl =
                            configs.cdDigitizerImagesUrl +
                            item.customDigitizingItems[0].imgLrgThumbnail.split(
                                "|"
                            )[0];
                        return imgUrl.toLowerCase();
                    } else if (
                        angular.isDefined(item.cdLineItems) &&
                        item.cdLineItems != null &&
                        item.cdLineItems.length > 0
                    ) {
                        imgUrl =
                            configs.cdDigitizerImagesUrl +
                            item.cdLineItems[0].imgLrgThumbnail.split("|")[0];
                        return imgUrl.toLowerCase();
                    }
                    //#endregion

                    // #region Instant Lettering
                    else if (
                        definitionName.toLowerCase() == "instantlettering"
                    ) {
                        if (item.ilLineItems[0].requestId.length > 7)
                            imageUrl =
                                window.__env.ilImageBaseUrl +
                                item.ilLineItems[0].requestId +
                                ".jpg";
                        else
                            imageUrl =
                                "/embroiderydesigns/images/instant_lettering.jpg";
                        return imageUrl.toLowerCase();
                    }

                    //#endregion

                    //#region Catalog
                    var catalog = "";
                    if (angular.isDefined(item.catalogId)) {
                        catalog = item.catalogId.replace(/ /g, "_");
                    }
                    if (catalog.toLowerCase() == "atg_freedesigns")
                        catalog = "anns_club";
                    else if (catalog.toLowerCase() == "annthegranpl")
                        catalog = "annthegran";
                    //#endregion

                    //#region Product Code
                    var productCode = "";
                    if (angular.isDefined(item.sku)) {
                        productCode =
                            item.sku.split(/-(.+)/).length > 1
                                ? item.sku.split(/-(.+)/)[1]
                                : item.sku.split(/-(.+)/)[0];
                    }
                    if (productCode.toLowerCase().indexOf("_var_") > -1) {
                        productCode = productCode.split(/_var_/gi)[0];
                    }
                    //#endregion

                    //#region RGB
                    var rgb = "";
                    if (angular.isDefined(item.rgb)) {
                        rgb = item.rgb;
                    }
                    //#endregion

                    //#region Size
                    var size = "";
                    if (angular.isDefined(item.size)) {
                        size = item.size;
                    }
                    // if (size != null && size != "") {
                    //     if (
                    //         definitionName.toLowerCase() == "fontpack" &&
                    //         size.toLowerCase() == "xlarge"
                    //     ) {
                    //         size = "large";
                    //     }
                    // }
                    if (size.length < 1) {
                        size = "large";
                    }
                    //#endregion

                    //#region Manufacturer Part Number
                    var manufacturerPartNumber = "";
                    if (angular.isDefined(item.product)) {
                        manufacturerPartNumber =
                            item.product.manufacturerPartNumber;
                    }
                    if (angular.isDefined(item.manufacturerPartNumber)) {
                        manufacturerPartNumber = item.manufacturerPartNumber;
                    }
                    //#endregion

                    //#region ImgBaseUrl
                    var imgBaseUrl = "https://img2.embroiderydesigns.com/"; // Default Fallback
                    if (
                        angular.isDefined(window.__env) &&
                        angular.isDefined(window.__env.storePrdImgUrl)
                    ) {
                        imgBaseUrl = window.__env.storePrdImgUrl;
                    }
                    //#endregion

                    //#region Threads
                    var showThreadVariants = false;
                    if (angular.isDefined(item.showThreadVariants)) {
                        showThreadVariants = item.showThreadVariants;
                    }
                    if (
                        definitionName.toLowerCase() == "thread" &&
                        showThreadVariants
                    ) {
                        imgUrl = imgBaseUrl + definitionName + "/" + size + "/";
                        if (
                            rgb != "" &&
                            angular.isDefined(item.threadConeImageName)
                        ) {
                            return (
                                "/common/images/thread_images/" +
                                item.threadConeImageName
                            ).toLowerCase();
                        } else {
                            imgUrl += "/threads/" + manufacturerPartNumber;
                            imgUrl += ".png";
                            return imgUrl.toLowerCase();
                        }
                    }
                    //#endregion

                    //#region ImgExtension
                    var imgExtension = ".webp";
                    if (
                        definitionName.toLowerCase() == "designpack" ||
                        definitionName.toLowerCase() == "fontpack"
                    ) {
                        imgExtension = ".webp";
                    }
                    //#endregion
                    //#region      for Merchandise ProductCode
                    if (definitionName.toLowerCase() == "merchandise") {
                        if (angular.isDefined(item.sku)) {
                            productCode =
                                item.sku.split(/-(.+)/).length > 1
                                    ? item.sku.split(/-(.+)/)[1]
                                    : item.sku.split(/-(.+)/)[0];
                        }
                        var variantId = productCode.split(/_var_/gi)[1];
                        if (variantId == "1") {
                            productCode = productCode.split(/_var_/gi)[0];
                        }
                        definitionName = "merchandise";
                    }
                    //#endregion

                    imgUrl =
                        imgBaseUrl +
                        definitionName +
                        "/" +
                        size +
                        "/" +
                        catalog +
                        "/" +
                        productCode +
                        imgExtension;
                    return imgUrl.toLowerCase();
                }
            },
            getProductVideoUrl: function (item) {
                if (angular.isDefined(item)) {
                    var videoUrl = "";
                    var videoBaseUrl = "";
                    if (window.__env && window.__env.productVideosBaseUrl) {
                        videoBaseUrl = window.__env.productVideosBaseUrl;
                    }

                    //#region Catalog
                    var catalog = "";
                    if (angular.isDefined(item.catalogId)) {
                        catalog = item.catalogId.replace(/ /g, "_");
                    }
                    if (catalog.toLowerCase() == "atg_freedesigns")
                        catalog = "anns_club";
                    else if (catalog.toLowerCase() == "annthegranpl")
                        catalog = "annthegran";
                    //#endregion

                    //#region Product Code
                    var productCode = "";
                    if (angular.isDefined(item.sku)) {
                        productCode =
                            item.sku.split(/-(.+)/).length > 1
                                ? item.sku.split(/-(.+)/)[1]
                                : item.sku.split(/-(.+)/)[0];
                    }
                    if (productCode.toLowerCase().indexOf("_var_") > -1) {
                        productCode = productCode.split(/_var_/gi)[0];
                    }
                    //#endregion

                    videoUrl =
                        videoBaseUrl + catalog + "/" + productCode + ".mp4";
                    return videoUrl.toLowerCase();
                }
            },
            getQueryString: function (param, url) {
                var href = url ? url : $location.$$absUrl;
                var reg = new RegExp("[?&]" + param + "=([^&#]*)", "i");
                var string = reg.exec(href);
                return string ? string[1] : null;
            },
            getProductUrl: function (item) {
                if (angular.isDefined(item)) {
                    //#region Definition
                    var definition = "";
                    if (angular.isDefined(item.definitionName)) {
                        definition = item.definitionName
                            .replace(/ /g, "-")
                            .toLowerCase();
                    } else if (angular.isDefined(item.productDefinition)) {
                        definition = item.productDefinition
                            .replace(/ /g, "-")
                            .toLowerCase();
                    }
                    //#endregion

                    //#region Brand
                    var brand = "";
                    if (angular.isDefined(item.catalogId)) {
                        brand = item.catalogId;

                        if (brand.toLowerCase() == "robison-anton") {
                            brand = "ct-company";
                        }
                    }
                    //#endregion

                    //#region ProductId
                    var productId = "";
                    if (angular.isDefined(item.sku)) {
                        productId = item.sku;
                    }
                    //#endregion

                    //#region Name
                    var title = "";
                    if (angular.isDefined(item.name)) {
                        title = item.name;
                    }
                    //#endregion

                    //#region LineItemId
                    var lineItemId = "";
                    if (angular.isDefined(item.id)) {
                        lineItemId = item.id;
                    }
                    //#endregion

                    //#region Cart Id
                    var cartId = undefined; // For GC on cart page
                    if (angular.isDefined(item.cartId)) {
                        cartId = item.cartId;
                    }
                    //#endregion

                    //#region cdRowId
                    var cdRowId = undefined; // For CD
                    if (
                        angular.isDefined(item.customDigitizingItems) &&
                        item.customDigitizingItems != null &&
                        item.customDigitizingItems.length > 0
                    ) {
                        cdRowId = item.customDigitizingItems[0].cdRowId;
                    } else if (
                        angular.isDefined(item.cdLineItems) &&
                        item.cdLineItems != null &&
                        item.cdLineItems.length > 0
                    ) {
                        cdRowId = item.cdLineItems[0].cdRowId;
                    }
                    //#endregion

                    //#region variant
                    var variant = 1;
                    //#endregion

                    if (angular.isDefined(definition)) {
                        if (definition.toLowerCase() == "project_tutorial") {
                            title = title
                                .replace(/\s|\/|\?/g, "-")
                                .replace(/&|\+/g, "")
                                .replace(/[^\w-]*/g, "")
                                .replace(/^[-]/g, "")
                                .replace(/[-]$/g, "")
                                .toLowerCase();
                            return (
                                "/how-to-embroider/project/" +
                                productId +
                                "/" +
                                title
                            ).toLowerCase();
                        } else if (definition.toLowerCase() == "lookbook") {
                            return (
                                "/learning-center/lookbooks?id=" + productId
                            ).toLowerCase();
                        } else if (catalogService.isSubscription(definition)) {
                            return "/account#/#customersubscription";
                        } else if (
                            definition.toLowerCase() == "giftcertificate" &&
                            angular.isUndefined(cartId)
                        ) {
                            return "/giftcard"; // Url on any other pages other than cart
                        } else if (
                            definition.toLowerCase() == "giftcertificate" &&
                            angular.isDefined(cartId) &&
                            angular.isDefined(lineItemId)
                        ) {
                            return (
                                "/giftcard?cartId=" +
                                cartId +
                                "&lineItemId=" +
                                lineItemId
                            ).toLowerCase(); // Url on cart page - ability to go back to GC page and change details if necessary
                        } else if (
                            definition.toLowerCase() == "customdigitizing"
                        ) {
                            return "customdigitizingdetails?cdrowid=" + cdRowId;
                        } else if (
                            definition.toLowerCase() == "instantlettering"
                        ) {
                            return "/onlinelettering";
                        } else {
                            if (definition == "Font") {
                                definition = "alphabets";
                            } else if (definition == "StockDesign") {
                                definition = "designs";
                            } else if (definition == "DesignPack") {
                                definition = "packs";
                            } else if (
                                definition == "PrintArt" ||
                                definition == "SVG"
                            ) {
                                definition = "printart";
                            } else if (definition.toLowerCase() == "threads") {
                                definition = "thread";
                            }
                            if (
                                angular.isDefined(brand) &&
                                brand.indexOf(" ") > 0
                            ) {
                                brand = brand.replace(/ |\//g, "-");
                            }
                            if (angular.isDefined(title) && title.length > 0) {
                                title = title
                                    .replace(/\s|\/|\\|\?/g, "-")
                                    .replace(/&/g, "");
                            }
                            if (
                                angular.isDefined(definition) &&
                                angular.isDefined(title) &&
                                title.indexOf("#") > 0
                            ) {
                                if (definition.toLowerCase() == "thread") {
                                    title = title.replace(/#/g, "-");
                                } else {
                                    title = title.replace(/#/g, "");
                                }
                            }
                            if (angular.isDefined(productId)) {
                                if (
                                    productId.toLowerCase().indexOf("_var_") > 1
                                ) {
                                    variant = productId.split(/_var_/gi)[1];
                                }
                                if (
                                    angular.isDefined(productId) &&
                                    productId.indexOf("-") > 1
                                ) {
                                    productId = productId
                                        .split(/-(.+)/)[1]
                                        .split(/_var_/gi)[0];
                                } else {
                                    productId = productId.split(/_var_/gi)[0];
                                }
                            }
                            var productUrl =
                                "productdetails/" +
                                brand +
                                "/" +
                                definition +
                                "/" +
                                variant +
                                "/" +
                                productId;
                            return productUrl.toLowerCase();
                        }
                    }
                }
            },
            getAuthorProjectsUrl: function (id, name) {
                if (angular.isDefined(id) && angular.isDefined(name)) {
                    name = name.replace(/\s|\/|\?/g, "-").replace(/&|\+/g, "");
                    return (
                        "/how-to-embroider/author/" +
                        name +
                        "/" +
                        id
                    ).toLowerCase();
                }
            },
            trackCustomerViewProduct: function (productId) {
                return $http.get(
                    "storefrontapi/product/trackcustomerbrowse/" + productId
                );
            },
        };
    },
]);
//#endregion

//#region Loader Service
storefrontApp.service("loaderService", [
    "modalService",
    function (modalService) {
        return {
            hide: function () {
                modalService.close("appLoader");
            },
            show: function () {
                modalService.open("appLoader");
            },
        };
    },
]);
//#endregion

//#region Main Service
storefrontApp.service("mainService", [
    "$http",
    function ($http) {
        return {
            getNavbarContent: function () {
                return $http.get("storefrontapi/navbarcontent");
            },
            getSuperHeaderAds: function () {
                return $http.get("storefrontapi/activesuperheaderads");
            },
            insertMailingListEmail: function (email, valid) {
                return $http.post(
                    "emailcampaign/insertmailinglistemail/" +
                        email +
                        "/" +
                        valid
                );
            },
            getSettingsByKey: function (key) {
                return $http.get("storefrontapi/settingsbykey?key=" + key);
            },
            getModuleKeys: function (key) {
                return $http.get("storefrontapi/modulekeys?key=" + key);
            },
        };
    },
]);
//#endregion

//#region Modal Service
storefrontApp.service("modalService", function () {
    var modals = [];
    var service = {};

    service.add = add;
    service.remove = remove;
    service.open = open;
    service.close = close;

    function add(modal) {
        modals.push(modal);
    }

    function remove(id) {
        var modalToRemove = _.findWhere(modals, { id: id });
        modals = _.without(modals, modalToRemove);
    }

    function open(id) {
        var modal = _.findWhere(modals, { id: id });
        modal && modal.open();
    }

    function close(id) {
        var modal = _.findWhere(modals, { id: id });
        modal && modal.close();
    }

    return service;
});
//#endregion

//#region Random Service
storefrontApp.service("randomService", [
    function () {
        return {
            getRandomItemsfromListArray: function (data, range) {
                range =
                    angular.isUndefined(range) || range === null ? 6 : range;
                if (range > data.length) {
                    range = data.length;
                }
                var randomItems = [];
                for (var i = 0; i < range; i++) {
                    var idx = Math.floor(Math.random() * data.length);
                    randomItems.push(data[idx]);
                    data.splice(idx, 1);
                }
                return randomItems;
            },
        };
    },
]);
//#endregion

//#region RecentlyViewedService
storefrontApp.service("recentlyViewedService", [
    function () {
        return {
            updateRecentlyViewed: function (productId) {
                if (!(angular.isUndefined(productId) || productId == "")) {
                    productId = productId.toLowerCase();
                    var recentlyViewed = localStorage.getItem("recentlyViewed");
                    if (recentlyViewed === null) {
                        localStorage.setItem("recentlyViewed", productId);
                    } else {
                        recentlyViewed = recentlyViewed.split(",");
                        var index = recentlyViewed.indexOf(productId);
                        if (index !== -1) {
                            recentlyViewed.splice(index, 1);
                        }
                        if (recentlyViewed.length > 11) {
                            recentlyViewed.pop();
                            recentlyViewed.splice(0, 0, productId);
                        } else {
                            recentlyViewed.splice(0, 0, productId);
                        }
                        localStorage.setItem(
                            "recentlyViewed",
                            recentlyViewed.toString()
                        );
                    }
                }
            },
        };
    },
]);
//#endregion

//#region Cart Service
storefrontApp.service("cartService", [
    "$http",
    function ($http) {
        return {
            addLineItem: function (productId, quantity) {
                var response = $http.post("storefrontapi/cart/items", {
                    id: productId,
                    quantity: quantity,
                });
                if (response && typeof gtag !== "undefined" && gtag !== null) {
                    gtag("event", "add_to_cart", {
                        items: [
                            {
                                item_id: productId,
                                quantity: 1,
                            },
                        ],
                    });
                }
                return response;
            },
            addAllVariantsAsLineItems: function (productId, quantity) {
                return $http.post("storefrontapi/cart/items", {
                    id: productId,
                    quantity: quantity,
                    isBuyAllVariants: true,
                });
            },
            removeLineItem: function (lineItemId) {
                return $http.delete(
                    "storefrontapi/cart/items?lineItemId=" + lineItemId
                );
            },
            removeLineItems: function (lineItemIds) {
                return $http.delete("storefrontapi/cart/multipleitems", {
                    params: { itemIds: lineItemIds },
                });
            },
            changeLineItemQuantity: function (lineItemId, quantity) {
                return $http.put("storefrontapi/cart/items", {
                    lineItemId: lineItemId,
                    quantity: quantity,
                });
            },
            getCustomerCart: function () {
                return $http.get(
                    "storefrontapi/cart?t=" + new Date().getTime()
                );
            },
            getCartForCheckout: function () {
                return $http.get(
                    "storefrontapi/cart/cartforcheckout?t=" +
                        new Date().getTime()
                );
            },
            addGiftCardProductToCart: function (
                product,
                recipientname,
                sendername,
                email,
                deliverydate,
                amount,
                message,
                giftcardimage,
                lineitemid
            ) {
                return $http.post("storefrontapi/cart/addgiftcardtocart", {
                    productid: product,
                    giftcardto: recipientname,
                    giftcardfrom: sendername,
                    giftcardtoemailid: email,
                    giftcarddeliverydate: deliverydate,
                    giftcardamount: amount,
                    giftcardmessage: message,
                    giftCardImage: giftcardimage,
                    lineItemId: lineitemid,
                });
            },
            addCoupon: function (couponCode) {
                var ccode = couponCode.toLowerCase();
                return $http.post("storefrontapi/cart/coupons/" + ccode);
            },
            removeCoupon: function (couponCode) {
                var ccode = couponCode.toLowerCase();
                return $http.delete(
                    "storefrontapi/cart/coupons?couponCode=" + ccode
                );
            },
            validateCoupon: function (coupon) {
                return $http.post(
                    "storefrontapi/cart/coupons/validate",
                    coupon
                );
            },
            getCartShippingEstimate: function (address) {
                return $http.post(
                    "storefrontapi/shipping/cartestimate",
                    address
                );
            },
            addInstantLetteringItemToCart: function (ilItem) {
                return $http.post("storefrontapi/cart/addilitemtocart", ilItem);
            },
            checkItemsInCustomPack: function () {
                return $http.get('storefrontapi/cart/checkdesignsincustompack');
            },
            guestCheckoutAccess: function (email) {
                return $http.get(
                    "storefrontapi/cart/accessguestcheckout/" + email
                );
            }
        };
    },
]);
//#endregion

// #region Favorites
storefrontApp.service("favoritesService", [
    "$http",
    function ($http) {
        return {
            getUserFavoriteItems: function (userId) {
                return $http.get(
                    "favorites/getfavoriteitemsbyuserid?userId=" +
                        userId +
                        "&t" +
                        Date.now()
                );
            },
            deleteItemFromFavorites: function (prodId, userId, grpName) {
                return $http.post("favorites/deleteitemfromfavorites", {
                    UserId: userId,
                    SKU: prodId,
                    GroupName: grpName,
                });
            },
            addItemToFavorites: function (prodId, userId, grpName) {
                var response = $http.post("favorites/additemtofavorites", {
                    userId: userId,
                    SKU: prodId,
                    GroupName: grpName,
                });
                if (response && typeof gtag !== "undefined" && gtag !== null) {
                    gtag("event", "add_to_wishlist", {
                        items: [
                            {
                                item_id: prodId,
                            },
                        ],
                    });
                }
                return response;
            },
            addBrandToFavorites: function (userId, brandName) {
                return $http.post("favorites/addbrandtofavorites", {
                    FK_UserId: userId,
                    BrandName: brandName,
                });
            },
            removeBrandFromFavorites: function (userId, brandName) {
                return $http.post("favorites/deletebrandfromfavorites", {
                    FK_UserId: userId,
                    BrandName: brandName,
                });
            },
            getFavoriteBrands: function (userId) {
                return $http.get(
                    "favorites/getfavoritebrandsbyuserid?userId=" +
                        userId +
                        "&t" +
                        Date.now()
                );
            },
            getFavoritegroups: function (userId) {
                return $http.get(
                    "favorites/getfavoritegroupsbyuserid?userId=" +
                        userId +
                        "&t" +
                        Date.now()
                );
            },
            createFavoritesGroup: function (favoritesGroup) {
                return $http.post(
                    "favorites/additemtofavorites",
                    favoritesGroup
                );
            },
            updateItemsFavoritesGroup: function (favoritesGroup) {
                return $http.post("favorites/updateitemsfavoritesgroup", {
                    FK_UserId: favoritesGroup.userId,
                    groupName: favoritesGroup.groupName,
                    itemIds: favoritesGroup.itemIds,
                });
            },
        };
    },
]);
//#endregion

// #region Sales / Specials
storefrontApp.service("specialsService", [
    "$http",
    function ($http) {
        return {
            getActiveSales: function (allSales) {
                return $http.get(
                    "storefrontapi/activesales?allsales=" + allSales
                );
            },
        };
    },
]);
storefrontApp.service("helperService", [
    "$http",
    function ($http) {
        return {
            getResetCacheState: function (key) {
                return $http.get(
                    "storefrontapi/cachesettingsbyconfigkey?key=" + key
                );
            },
            isValidTimeZone: function (tz) {
                try {
                    Intl.DateTimeFormat(undefined, { timeZone: tz });
                    return true;
                } catch (ex) {
                    return false;
                }
            },
            getCSTTimeZone: function (time) {
                if (this.isValidTimeZone("CST")) {
                    return new Date(
                        time.toLocaleString("en-US", { timeZone: "CST" })
                    ).getDate();
                } else {
                    return new Date(Date.now()).getDate();
                }
            },
            getContent: function (value) {
                if (angular.isUndefined(value) || value === null) {
                    return null;
                }
                storedValues = value.split("expiry:");
                if (storedValues != null && storedValues.length > 1) {
                    var currentDate = window.currentDate
                        .toString()
                        .match(/\d{1,2}\/\d{1,2}\/\d{4}/)[0];
                    var regexValues = storedValues[1].match(
                        /\d{1,2}\/\d{1,2}\/\d{4}/
                    );
                    if (regexValues != null) {
                        var storedDate = regexValues[0];
                        if (storedDate == currentDate) {
                            return storedValues[0];
                        }
                    }
                    return null;
                }
                return null;
            },
            downloadFileFromUrl: function (url, fileName) {
                fetch(url).then(function (t) {
                    return t.blob().then(function (b) {
                        var a = document.createElement("a");
                        a.href = URL.createObjectURL(b);
                        a.setAttribute("download", fileName);
                        a.click();
                    });
                });
            },
        };
    },
]);
//#endregion
